import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskPracticeNewRoute: InvariantJiraRoute = {
	name: 'servicedesk-practice-new',
	path: '/jira/servicedesk/projects/:projectKey/section/:practiceType/custom/new',
	query: ['parentId?'],
	exact: true,
};
